export const nonCommercialFeatures = [
  "FREE",
  "Single Drill",
  "1 Profile",
];

export const limitedTrialFeatures = [
  "FREE for 30 days",
  "All Index Drills",
  "5 Profiles",
];

export const personalLicenseFeatures = [
  "$50 per month ($500 annually)",
  "All index Drills",
  "5 Profiles",
  "Personal Portal",
  "Limited Locker",
  "Basic Support",
];

export const clubLicenseFeatures = [
  "$500 per month ($5000 annually)",
  "All index Drills",
  "Unlimited Profiles",
  "Club Portal",
  "Full Locker",
  "Premium Support",
  "Batch Upload",
  "2 Add-ons Included",
];

export const eliteLicenseFeatures = [
  "$1000 per month ($10000 annually)",
  "All index Drills",
  "Unlimited Profiles",
  "Elite Portal",
  "Full Locker",
  "Premium Support",
  "Batch Upload",
  "All Add-ons Included",
];
